





















































































import Vue from 'vue'

export default Vue.extend({
  name: 'SectionInfo',
  props: {
    label: {
      type: String,
      default: ''
    },
    withTooltip: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: '-'
    },
    color: {
      type: String,
      default: ''
    },
    matchesById: {
      type: Boolean,
      default: false
    },
    matchesByName: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    onClickIcon: {
      type: Function,
      default: () => {}
    }
  }
})
